export enum PasoCertificado {
      Tipo = 1,
      AfiliacionUsuarios = 2,
      MedioEnvio = 3,
      Confirmacion = 4,
      RetefuenteAnio = 5,
    }